import React from 'react';
import styles from './Header.module.css';

const Header = () => {
  return (
    <div className={styles.header}>
      <img
        src="https://bq-open-to-public.s3.amazonaws.com/email_logo.png"
        alt="Company Logo"
        className={styles.logo}
      />
      <h1>Care Management Portal</h1>
    </div>
  );
};

export default Header;
